import * as React from "react";
import { useSelector } from "react-redux";
import { decode } from "html-entities";

export default function NewsItem(props) {
  const system = useSelector((state) => state.systemReducer);
  const news = props.news;

  const itemToggle = () => {
    if (
      props.selectedNews.filter((item) => {
        return item.nid === news.nid;
      }).length > 0
    ) {
      props.removeSelectedNewsItem(news);
    } else {
      props.addSelectedNewsItem(news);
    }
  };

  return (
    <div
      key={`news-item-${news.nid}`}
      className={`news-item ${
        props.selectedNews.filter((item) => {
          return item.nid === news.nid;
        }).length > 0
          ? "selected"
          : ""
      }`}
      onClick={() => itemToggle()}
    >
      {props.selectedNews.filter((item) => {
        return item.nid === news.nid;
      }).length > 0 && <div className="selected-news-item-marker"></div>}

      {props.selectedNews.filter((item) => {
        return item.nid === news.nid;
      }).length > 0 && (
        <svg
          className="selected-news-item-marker-check"
          focusable="false"
          aria-hidden="true"
          viewBox="0 0 24 24"
          data-testid="CheckIcon"
        >
          <path d="M9 16.17 4.83 12l-1.42 1.41L9 19 21 7l-1.41-1.41z"></path>
        </svg>
      )}
      <div className="news-item-image">
        <img src={`https://${system.subdomain}.companyapp.net${news.field_featured_image}`} />
      </div>
      <div className="news-item-title">{decode(news.title)}</div>
    </div>
  );
}
